<link href="//fonts.googleapis.com/css?family=Playfair+Display:400,400i,700,700i,900" rel="stylesheet">
<link href="//fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700" rel="stylesheet">
<!-- HOME HEADER -->
<app-header></app-header>
<!--CONTENT-->
<div id="home" class="mt-4 mb-5">
  <div class="phone-seaech justify-content-center ml-4 mt-3" style="width: 90%">
    <input [(ngModel)]="keyword" class="form-search p-3 bg-white border-0 text-center opacity-4" style="width: 600px; border-bottom-left-radius: 40px; border-top-left-radius: 40px; font-size: 20px" placeholder="Browse Announces...">
    <button (click)="getSearchKey()" class="material-icons bg-white text-white border-0 opacity-4 text-primary" style="font-size: 40px; cursor: pointer; border-bottom-right-radius: 40px; border-top-right-radius: 40px">search</button>
  </div>
  <br><br><hr>
  <app-all-announces></app-all-announces>
<!--  <br><br>-->
<!--  <div class="d-flex justify-content-center">-->
<!--    <ul class="pagination centrer rounded" style="background-color: rgba(0, 0, 0, 0.6); width: fit-content;">-->
<!--      <li class="page-item disabled"><a class="page-link" href="#">Previous</a></li>-->
<!--      <li class="page-item "><a class="page-link" href="#">1</a></li>-->
<!--      <li class="page-item"><a class="page-link" href="#">2</a></li>-->
<!--      <li class="page-item"><a class="page-link" href="#">3</a></li>-->
<!--      <li class="page-item"><a class="page-link" href="#">Next</a></li>-->
<!--    </ul>-->
<!--  </div>-->
</div>
<div class="d-flex justify-content-center p-4" style="background-color: rgba(0, 0, 0, 0.6); margin-top: -50px">
  <span style="font-size: 25px" class="text-white"><i class="material-icons mr-2 font-weight-bold" style="font-size: 45px">group</i>Partenaires</span>
  <div class="container-fluid">
    <div class="row marg">
      <div class="col">
        <img src="../../assets/pictures/partners/addoha.jpg" class="img-partenaire" alt="">
      </div>
      <div class="col">
        <img src="../../assets/pictures/partners/omran.png" class="img-partenaire" alt="">
      </div>
      <div class="col">
        <img src="../../assets/pictures/partners/addoha.jpg" class="img-partenaire" alt="">
      </div>
      <div class="col">
        <img src="../../assets/pictures/partners/omran.png" class="img-partenaire" alt="">
      </div>
      <div class="col">
        <img src="../../assets/pictures/partners/omran.png" class="img-partenaire" alt="">
      </div>

    </div>
  </div>
</div>
<!-- HOME FOOTER-->
<app-footer></app-footer>
